import { render, staticRenderFns } from "./CartPayInfo.vue?vue&type=template&id=024f8bd1&scoped=true&"
import script from "./CartPayInfo.vue?vue&type=script&lang=js&"
export * from "./CartPayInfo.vue?vue&type=script&lang=js&"
import style0 from "./CartPayInfo.vue?vue&type=style&index=0&id=024f8bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f8bd1",
  null
  
)

export default component.exports